// line-chart.component.ts
import { Component, Input, AfterViewInit, ChangeDetectorRef, OnInit} from '@angular/core';
import { BackendApiService } from "../../../app/services/backend-api.service";
import * as $ from 'jquery';
import * as CanvasJS from "../device-detail-nxt/canvasjs.stock.min";
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';
import { textChangeRangeIsUnchanged } from 'typescript';
import { LeafletMapComponent } from '../../admin/leaflet-map/leaflet-map.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class LineChartComponent implements OnInit, AfterViewInit {
  isLoading: boolean = false;
  @Input() chartData: any; 
  @Input() chartOptions: any;
  @Input() chartBgColors:any
  @Input() chartContainerId: any;
  @Input() movingAvgData: any;
  @Input() chartSymbol:any;
  @Input() powerFactorStripLines:any=[];
  @Input() freqStripLines:any=[];
  @Input() voltageStripLines:any=[];
  @Input() kwStripLines:any=[];
  @Input() kvaStripLines:any=[];
  @Input() metricIds='';
  @Input() asset_id='';
  @Input() device_id='';
  @Input() subsystem_id='';
  public graphID:string;
  public valueType: string;
  public time_span: string;
  public accColor1: any = "active";
  public accColor2: any;
  public accColor3: any;
  public boilerParameter = BaseUrlConstantsService.BOILER_PARAMETERS_API;
  public nergymeterParameter = BaseUrlConstantsService.energyMeterApi;
  public cylinderBaseUrl = BaseUrlConstantsService.CYLINDER_BASE_URL;
  public clientId: string;
  public subsystemId: string;
  public serialNumber: string;
  public chartType: any;
  public errorMessage: string;
  axisXData: { gridThickness: number; tickLength: number; lineThickness: number; labelFontSize: number; };
  minimum: number;
  maximum: any;
  navigatorEnabled: boolean;
  labelFormatter: (e: any) => string;
  public day_1: any = 0;
  public days_7: any = 0;
  public days_30: any= 0;
  public chartUnit: any;
  generic_asset_id: any;
  constructor(private cdr: ChangeDetectorRef,
    private service: BackendApiService
  ) {
    if(localStorage.getItem('role') === 'ADMIN'){
      this.clientId = localStorage.getItem('admin_client_id');
    }else{
      this.clientId = localStorage.getItem('user_id');
    }
    if (localStorage.getItem('role') === "USER") {
      this.clientId = localStorage.getItem("associated_clientid");
    }
    this.subsystemId = localStorage.getItem('subsystem_id');
    this.serialNumber=localStorage.getItem('serial_number');
  }
  ngOnInit(){
    if(localStorage.getItem('role') === 'ADMIN'){
      this.clientId = localStorage.getItem('admin_client_id');
    }else{
      this.clientId = localStorage.getItem('user_id');
    }
    this.generic_asset_id = localStorage.getItem('generic_asset_id');
    this.subsystemId = localStorage.getItem('subsystem_id');
    this.chartType = JSON.parse(JSON.stringify(this.chartData))[0].type;

  }
  ngAfterViewInit() {
    if (this.chartData && this.chartOptions && this.chartContainerId) {
      if(localStorage.getItem('role') == 'USER'){
        this.clientId = localStorage.getItem('associated_clientid');
      }
      let chartContainerId = this.chartContainerId;
      this.graphID = chartContainerId;      
      // Cloning the chartData array to preserve the original data
      let chartDataOriginal = JSON.parse(JSON.stringify(this.chartData));
      let chartRangeDataOriginal = JSON.parse(JSON.stringify(this.chartBgColors));
      if(this.movingAvgData != undefined && this.movingAvgData.day_1 != undefined){
        this.day_1 = this.movingAvgData.day_1.toFixed(2);
        this.days_7 = this.movingAvgData.days_7.toFixed(2);
        this.days_30 = this.movingAvgData.days_30.toFixed(2);
      }
      else if(this.movingAvgData != undefined && this.evaluateRotatingAssetMovingAvg(this.chartContainerId)){
        this.day_1 = this.movingAvgData[0].x_hour?this.movingAvgData[0]?.x_hour:0
        this.days_7 = this.movingAvgData[0].x_day?this.movingAvgData[0]?.x_day:0
        this.days_30 = this.movingAvgData[0].x_week?this.movingAvgData[0]?.x_week:0
      }
      else{
        this.day_1 = 0;
        this.days_7 = 0;
        this.days_30 = 0;
      }

      
      if(chartDataOriginal[0].dataPoints.length!== 0 && chartDataOriginal[0].type ==='line'){
        this.errorMessage = "";
        this.axisXData = {
          gridThickness: 0,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
        }
        
          this.minimum= 0,  // Minimum value for the y-axis
          this.maximum= chartRangeDataOriginal.max_value;
          this.navigatorEnabled = true;
      }else if(chartDataOriginal[0].type !=='line' && chartDataOriginal[0].dataPoints.length !== 0){
          this.minimum =0;  // Minimum value for the y-axis
          this.maximum= 1;
          this.navigatorEnabled= true;
          this.labelFormatter= function(e){
            return  "";
          }
      }else if((chartDataOriginal[0].type ==='line' || chartDataOriginal[0].type ==='column') && chartDataOriginal[0].dataPoints.length === 0){
        this.axisXData = {
          gridThickness: 0,
          tickLength: 0,
          lineThickness: 0,
          labelFontSize: 12,
        }
          this.minimum =0,  // Minimum value for the y-axis
          this.maximum =0,
          this.navigatorEnabled= false;
        this.errorMessage ="No data available.";
      }
      // Creating a modified version of chartData with showInLegend set to false
      let chartDataSmallScreen = JSON.parse(JSON.stringify(this.chartData));      
      this.chartUnit = this.chartData[0].unit;
      chartDataSmallScreen.forEach((data: any) => {
        if (data.hasOwnProperty('showInLegend')) {
          data.showInLegend = false;
        }
      });


      //Line chart:: create instance. 
      //Data for small charts displayed on dashboard screen
      let chart = new CanvasJS.Chart(this.chartContainerId, {
        theme: "light2",
        animationEnabled: true,
        exportEnabled: false,
        zoomEnabled: true,
        title: {
          text: this.chartOptions.toUpperCase(),
          margin: 0
        },   
        subtitles:[
          {
            text: chartDataOriginal[0].dataPoints.length == 0?"No data available.":"",
            verticalAlign: "center",
            horizontalAlign:'center',
            fontWeight: "bold"
          }
        ],   
        // axisX:this.axisXData,
        axisX: {
          labelFormatter: () => "",
        },
        data: chartDataSmallScreen,
        axisY:{
          minimum: this.powerFactorStripLines.length?this.powerFactorStripLines[0]:
          this.freqStripLines.length?this.freqStripLines[0]:
          this.voltageStripLines?.length?this.voltageStripLines[0]:
          this.kwStripLines?.length?this.kwStripLines[0]:
          this.kvaStripLines?.length?this.kvaStripLines[0]:
          this.minimum,
          maximum: this.maximum,
          labelFormatter:this.labelFormatter,
          stripLines: this.powerFactorStripLines.length?this.evaluatePowerFactorStripLine(this.maximum): 
          this.freqStripLines.length?this.evaluateFrequencyStripLine(this.maximum):
          this.voltageStripLines?.length?this.evaluateVoltageStripLine(this.maximum): 
          this.kwStripLines?.length?this.evaluateKwStripLine(this.maximum): 
          this.kvaStripLines?.length?this.evaluateKvaStripLine(this.maximum): 
          [{ startValue: 0,
            endValue: chartRangeDataOriginal.green,
            color: "rgba(212, 237, 218, 1)" // Use rgba for transparency}]
                        
          },
          {
                value: chartRangeDataOriginal.green,
                label: chartRangeDataOriginal.green.toString(),
                labelFontColor: "#000000",
                labelAlign: "right",
          },
          {
            startValue: chartRangeDataOriginal.green,
            endValue: chartRangeDataOriginal.yellow,
            color: "rgba(255, 250, 196, 1)"
          },
          {
                value: chartRangeDataOriginal.yellow,
                label: chartRangeDataOriginal.yellow.toString(),
                labelFontColor: "#000000",
                labelAlign: "right",
          },
          {
                startValue: chartRangeDataOriginal.yellow,
                endValue: chartRangeDataOriginal.red,
                color: "rgba(255, 230, 230, 0.5)"
          },
          {
                value: chartRangeDataOriginal.red,
                label: chartRangeDataOriginal.red.toString(),
                labelFontColor: "#000000",
                labelAlign: "right",
          }
        ]
        },
        toolTip: {
          contentFormatter: function (e) {
            return  `${e.entries[0].dataPoint.label}:  `+e.entries[0].dataPoint.y+ ` ${chartDataOriginal[0].unit?chartDataOriginal[0].unit:""}`;
          },
          enabled: true,
        },
        // toolTip: {
        //   contentFormatter: function (e) {
        //     console.log(e)
        //     let content = ""; 
        
        //     e.entries.forEach((entry) => {
        //       console.log(entry)
        //       let dataPoint = entry.dataPoint;
        //       let label = dataPoint.label;
        //       let value = dataPoint.y; // Y-axis value
        //       let seriesName = entry?.dataSeries?.name || 'test'; // Name of the series
        
        //       content += `${seriesName}: ${value} ${chartDataOriginal[0].unit || ""}<br/>`; 
        //     });
        
        //     return content;
        //   },
        //   enabled: true,
        // }
      });
      
      chart.render();
      let chart2;

      //Line chart:: copy above instance from chart to chart2 for modal. 
      chart2 = new CanvasJS.StockChart(this.chartContainerId + '_2', {
        theme: "light2",
        animationEnabled: true,
        exportEnabled: false,
        zoomEnabled: true,
        legend: {
          legendMarkerColor: "none",
          verticalAlign: "top",
          horizontalAlign: "center",
          showInLegend: true,
          legendText: "Numbers",
          fontSize: 19,
          fontColor: "#191919",
          fontWeight: "normal",
          markerMargin: 10,
          fontFamily: "Roboto-Regular",
          cursor: "pointer",
          itemclick: function (e) {
            if (
              typeof e.dataSeries.visible === "undefined" ||
              e.dataSeries.visible
            ) {
              e.dataSeries.visible = false;
            } else {
              e.dataSeries.visible = true;
            }
            e.chart.render();
          },
        },    
        title: {
            text: this.chartOptions.toUpperCase(),
            fontFamily: "Roboto-Regular",
            fontColor: "#444",
            fontSize: 30,
            margin: 10
        },
       
        rangeSelector: {
         enabled: false
        },
        navigator: {
            enabled: this.navigatorEnabled
        },
        charts: [{
            axisX: this.axisXData,
            data: chartDataOriginal,
            toolTip: {
              contentFormatter: function (e) {
                return  `${e.entries[0].dataPoint.label}:  `+e.entries[0].dataPoint.y+ ` ${chartDataOriginal[0].unit?chartDataOriginal[0].unit:" "}`;
              },
              enabled: true,
            },
            axisY: {
              minimum: this.powerFactorStripLines.length?this.powerFactorStripLines[0]:
                      this.freqStripLines.length?this.freqStripLines[0]:
                      this.voltageStripLines?.length?this.voltageStripLines[0]:
                      this.kwStripLines?.length?this.kwStripLines[0]:
                      this.kvaStripLines?.length?this.kvaStripLines[0]:
                      this.minimum,
              maximum: this.maximum,
              labelFontSize: 12,
              labelFormatter:this.labelFormatter, 
              enabled:this.navigatorEnabled,
              stripLines:this.powerFactorStripLines.length?this.evaluatePowerFactorStripLine(this.maximum): 
              this.freqStripLines.length?this.evaluateFrequencyStripLine(this.maximum):
              this.voltageStripLines?.length?this.evaluateVoltageStripLine(this.maximum):
              this.kwStripLines?.length?this.evaluateKwStripLine(this.maximum):
              this.kvaStripLines?.length?this.evaluateKvaStripLine(this.maximum):
               [{ startValue: 0,
                endValue: chartRangeDataOriginal.green,
                color: "rgba(212, 237, 218, 1)" // Use rgba for transparency}]
                            
              },
              {
                    value: chartRangeDataOriginal.green,
                    label: chartRangeDataOriginal.green.toString(),
                    labelFontColor: "#000000",
                    labelAlign: "right",
              },
              {
                startValue: chartRangeDataOriginal.green,
                endValue: chartRangeDataOriginal.yellow,
                color: "rgba(255, 250, 196, 1)"
              },
              {
                    value: chartRangeDataOriginal.yellow,
                    label: chartRangeDataOriginal.yellow.toString(),
                    labelFontColor: "#000000",
                    labelAlign: "right",
              },
              {
                    startValue: chartRangeDataOriginal.yellow,
                    endValue: chartRangeDataOriginal.red,
                    color: "rgba(255, 230, 230, 0.5)"
              },
              {
                    value: chartRangeDataOriginal.red,
                    label: chartRangeDataOriginal.red.toString(),
                    labelFontColor: "#000000",
                    labelAlign: "right",
              }
            ]
            },
            subtitles: [
              {
                  text: chartDataOriginal[0].dataPoints.length == 0 ? "No data available." : "",
                  verticalAlign: "center",
                  horizontalAlign: 'center',
                  fontWeight: "bold"
              }
          ],
        }]

    });
      //Open specific line chart in modal .
      $('#'+this.chartContainerId).click(function(){
        $('#'+chartContainerId+'_background, #'+chartContainerId+'_modal').hide();
        $('#'+chartContainerId+'_background, #'+chartContainerId+'_modal').show();
        chart2.render();

        setTimeout(() => {
        }, 1000);
        
        

    });
      //Close modal.
      $('#'+chartContainerId+'_background, #closeBtn').click(function(){
        $('#'+chartContainerId+'_background, #'+chartContainerId+'_modal').hide();
      });
    }else{

    }
  }

  evaluatePowerFactorStripLine(max){
    return [
        {
          startValue: 0,
          endValue: Number(this.powerFactorStripLines[1]),
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.powerFactorStripLines[1]),
          label:Number(this.powerFactorStripLines[1]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.powerFactorStripLines[1]),
          endValue: Number(this.powerFactorStripLines[2]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.powerFactorStripLines[2]),
          label:Number(this.powerFactorStripLines[2]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.powerFactorStripLines[2]),
          endValue: Number(this.powerFactorStripLines[3]),
          color: "rgba(212, 237, 218, 1)",
        },
        {
          value:Number(this.powerFactorStripLines[3]),
          label:Number(this.powerFactorStripLines[3]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.powerFactorStripLines[3]),
          endValue: Number(this.powerFactorStripLines[4]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.powerFactorStripLines[4]),
          label:Number(this.powerFactorStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.powerFactorStripLines[4]),
          endValue: Number(max),
          color: "rgba(255, 230, 230, 0.5)"
        },
        {
          value:Number(this.powerFactorStripLines[4]),
          label:Number(this.powerFactorStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.powerFactorStripLines[5]),
          endValue: Number(max),
          color: "rgba(255, 230, 230, 0.5)"
        },
        {
          value:Number(this.powerFactorStripLines[5]),
          label:Number(this.powerFactorStripLines[5]),
          labelFontColor: "black",
          labelAlign:"right"
        }
      ]
}
  evaluateFrequencyStripLine(max){  
    return [
        {
          startValue: 0,
          endValue: Number(this.freqStripLines[1]),
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.freqStripLines[1]),
          label:Number(this.freqStripLines[1]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.freqStripLines[1]),
          endValue: Number(this.freqStripLines[2]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.freqStripLines[2]),
          label:Number(this.freqStripLines[2]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.freqStripLines[2]),
          endValue: Number(this.freqStripLines[3]),
          color: "rgba(212, 237, 218, 1)",
        },
        {
          value:Number(this.freqStripLines[3]),
          label:Number(this.freqStripLines[3]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.freqStripLines[3]),
          endValue: Number(this.freqStripLines[4]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.freqStripLines[4]),
          label:Number(this.freqStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.freqStripLines[4]),
          endValue: max,
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.freqStripLines[4]),
          label:Number(this.freqStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.freqStripLines[5]),
          endValue: max,
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.freqStripLines[4]),
          label:Number(this.freqStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
      ]
}
  evaluateVoltageStripLine(max){  
    return [
        {
          startValue: Number(this.voltageStripLines[0]),
          endValue: Number(this.voltageStripLines[1]),
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.voltageStripLines[1]),
          label:Number(this.voltageStripLines[1]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.voltageStripLines[1]),
          endValue: Number(this.voltageStripLines[2]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.voltageStripLines[2]),
          label:Number(this.voltageStripLines[2]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.voltageStripLines[2]),
          endValue: Number(this.voltageStripLines[3]),
          color: "rgba(212, 237, 218, 1)",
        },
        {
          value:Number(this.voltageStripLines[3]),
          label:Number(this.voltageStripLines[3]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.voltageStripLines[3]),
          endValue: Number(this.voltageStripLines[4]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.voltageStripLines[4]),
          label:Number(this.voltageStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.voltageStripLines[4]),
          endValue: max,
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.voltageStripLines[4]),
          label:Number(this.voltageStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
      ]
}
  evaluateKwStripLine(max){  
    return [
        {
          startValue: Number(this.kwStripLines[0]),
          endValue: Number(this.kwStripLines[1]),
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.kwStripLines[1]),
          label:Number(this.kwStripLines[1]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kwStripLines[1]),
          endValue: Number(this.kwStripLines[2]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.kwStripLines[2]),
          label:Number(this.kwStripLines[2]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kwStripLines[2]),
          endValue: Number(this.kwStripLines[3]),
          color: "rgba(212, 237, 218, 1)",
        },
        {
          value:Number(this.kwStripLines[3]),
          label:Number(this.kwStripLines[3]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kwStripLines[3]),
          endValue: Number(this.kwStripLines[4]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.kwStripLines[4]),
          label:Number(this.kwStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kwStripLines[4]),
          endValue: max,
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.kwStripLines[4]),
          label:Number(this.kwStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
      ]
}
  evaluateKvaStripLine(max){  
    return [
        {
          startValue: Number(this.kvaStripLines[0]),
          endValue: Number(this.kvaStripLines[1]),
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.kvaStripLines[1]),
          label:Number(this.kvaStripLines[1]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kvaStripLines[1]),
          endValue: Number(this.kvaStripLines[2]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.kvaStripLines[2]),
          label:Number(this.kvaStripLines[2]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kvaStripLines[2]),
          endValue: Number(this.kvaStripLines[3]),
          color: "rgba(212, 237, 218, 1)",
        },
        {
          value:Number(this.kvaStripLines[3]),
          label:Number(this.kvaStripLines[3]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kvaStripLines[3]),
          endValue: Number(this.kvaStripLines[4]),
          color: "rgba(255, 250, 196, 1)",
        },
        {
          value:Number(this.kvaStripLines[4]),
          label:Number(this.kvaStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
        {
          startValue: Number(this.kvaStripLines[4]),
          endValue: max,
          color: "rgba(255, 230, 230, 0.5)",
        },
        {
          value:Number(this.kvaStripLines[4]),
          label:Number(this.kvaStripLines[4]),
          labelFontColor: "black",
          labelAlign:"right"
        },
      ]
}


  selectFilterAccelartion(value,type) {
    switch (value) {
      case "Hourly":
        //this.valueTypeTrend = "hour";
        this.valueType = "hour";
        this.time_span = "hour";
        this.getChartData(this.valueType, type);
        this.accColor1 = "active";
        this.accColor2 = "";
        this.accColor3 = "";
        break;
      case "Daily":
        //this.valueTypeTrend = "day";
        this.valueType = "day";
        this.time_span = "day";
        this.getChartData(this.valueType, type);
        this.accColor1 = "";
        this.accColor2 = "active";
        this.accColor3 = "";
        break;
      case "Weekly":
        //this.valueTypeTrend = "week";
        this.valueType = "week";
        this.time_span = "week";
        this.getChartData(this.valueType, type);
        this.accColor2 = "";
        this.accColor1 = "";
        this.accColor3 = "active";
        break;
    }
  }

    getChartData(time_span, type) {
      this.isLoading = true;
      this.graphID = type;
      if(localStorage.getItem('role') == 'USER'){
        // this.chartContainerId = localStorage.getItem('associated_clientid');
        this.clientId = localStorage.getItem('associated_clientid');
      }
      $('#'+this.chartContainerId + '_2').html("");
      let endPoint = '';
      if (type === 'trends-voltage' || 
          type === 'trends-harmonic-distortion' || 
          type === 'trends-current' || 
          type === 'trends-frequency' || 
          type === 'trends-power-factor' || 
          type === 'trends-kw-demand' || 
          type === 'trends-cumulative-energy' || 
          type === 'trends-cumulative-energy-v2' || 
          type === 'trends-kva-demand') {
        endPoint = `${this.nergymeterParameter}/${type}/${this.clientId}/${this.generic_asset_id}/${time_span}`;
      } 
      else if(
          type === 'trends-acc' || 
          type === 'trends-velocity' || 
          type === 'trends-usound' || 
          type === 'trends-temp' || 
          type === 'trends-flow' || 
          type === 'trends-pressure'  
      ){
        endPoint = `${this.cylinderBaseUrl}/cylinder/trends/${type}/${this.clientId}/${this.asset_id}/${this.device_id}/${time_span}/${this.metricIds}/${this.subsystem_id}`;
      }
      else {
        endPoint = `${this.boilerParameter}${type}/${this.clientId}/${this.subsystemId}/${time_span}`;
      }
      this.service.getData(endPoint).then(res => {
        let response = JSON.parse(JSON.stringify(res)).data;
        this.isLoading = false;
        if (response.body.sensor.length != 0) {
          let chartDataOriginal = response.body.sensor;
          let chartRangeDataOriginal = response.body.rangeLabels;
          if (chartDataOriginal[0].dataPoints.length !== 0 && chartDataOriginal[0].type === 'line') {
            this.errorMessage = "";
            this.axisXData = {
              gridThickness: 0,
              tickLength: 0,
              lineThickness: 0,
              labelFontSize: 12,
            };
            this.minimum = 0;
            this.maximum = chartRangeDataOriginal.max_value;
            this.navigatorEnabled = true;
          } else if (chartDataOriginal[0].type !== 'line' && chartDataOriginal[0].dataPoints.length !== 0) {
            this.minimum = 0;
            this.maximum = 1;
            this.navigatorEnabled = true;
            this.labelFormatter = function (e) {
              return "";
            };
          } else if ((chartDataOriginal[0].type === 'line' || chartDataOriginal[0].type === 'column') && chartDataOriginal[0].dataPoints.length === 0) {
            this.axisXData = {
              gridThickness: 0,
              tickLength: 0,
              lineThickness: 0,
              labelFontSize: 12,
            };
            this.minimum = 0;
            this.maximum = 0;
            this.navigatorEnabled = false;
            this.errorMessage = "No data available.";
          }

          setTimeout(() => {
            let chart2 = new CanvasJS.StockChart(this.chartContainerId + '_2', {
              height:680,
              theme: "light2",
              animationEnabled: true,
              exportEnabled: false,
              zoomEnabled: true,
              legend: {
                legendMarkerColor: "none",
                verticalAlign: "top",
                horizontalAlign: "center",
                showInLegend: true,
                legendText: "Numbers",
                fontSize: 19,
                fontColor: "#191919",
                fontWeight: "normal",
                markerMargin: 10,
                fontFamily: "Roboto-Regular",
                cursor: "pointer",
                itemclick: function (e) {
                  if (
                    typeof e.dataSeries.visible === "undefined" ||
                    e.dataSeries.visible
                  ) {
                    e.dataSeries.visible = false;
                  } else {
                    e.dataSeries.visible = true;
                  }
                  e.chart.render();
                },
              },
              title: {
                text: this.chartOptions,
                fontFamily: "Roboto-Regular",
                fontColor: "#444",
                fontSize: 30,
                margin: 10
              },
             
              rangeSelector: {
                enabled: false
              },
              toolTip: {
                contentFormatter: function (e) {
                  return  `${e.entries[0].dataPoint.label}:  `+e.entries[0].dataPoint.y+ ` ${chartDataOriginal[0].unit?chartDataOriginal[0].unit:" "}`;
                },
                enabled: true,
              },
              navigator: {
                enabled: this.navigatorEnabled
              },
              charts: [{
                axisX: this.axisXData,
                data: chartDataOriginal,
                axisY: {
                  minimum: this.powerFactorStripLines.length?this.powerFactorStripLines[0]:
                  this.freqStripLines.length?this.freqStripLines[0]:
                  this.voltageStripLines?.length?this.voltageStripLines[0]:
                  this.kwStripLines?.length?this.kwStripLines[0]:
                  this.kvaStripLines?.length?this.kvaStripLines[0]:
                  this.minimum,
                  maximum: this.maximum,
                  labelFormatter: this.labelFormatter,
                  enabled: this.navigatorEnabled,
                  
                  stripLines: this.powerFactorStripLines.length?this.evaluatePowerFactorStripLine(this.maximum):
                  this.freqStripLines.length?this.evaluateFrequencyStripLine(this.maximum):
                  this.voltageStripLines?.length?this.evaluateVoltageStripLine(this.maximum):
                  this.kwStripLines?.length?this.evaluateKwStripLine(this.maximum):
                  this.kvaStripLines?.length?this.evaluateKvaStripLine(this.maximum):
                    [{
                    startValue: 0,
                    endValue: chartRangeDataOriginal.green,
                    color: "rgba(212, 237, 218, 1)" // Use rgba for transparency
                  },
                  {
                    value: chartRangeDataOriginal.green,
                    label: chartRangeDataOriginal.green.toString(),
                    labelFontColor: "#000000",
                    labelAlign: "right",
                  },
                  {
                    startValue: chartRangeDataOriginal.green,
                    endValue: chartRangeDataOriginal.yellow,
                    color: "rgba(255, 250, 196, 1)"
                  },
                  {
                    value: chartRangeDataOriginal.yellow,
                    label: chartRangeDataOriginal.yellow.toString(),
                    labelFontColor: "#000000",
                    labelAlign: "right",
                  },
                  {
                    startValue: chartRangeDataOriginal.yellow,
                    endValue: chartRangeDataOriginal.red,
                    color: "rgba(255, 230, 230, 0.5)"
                  },
                  {
                    value: chartRangeDataOriginal.red,
                    label: chartRangeDataOriginal.red.toString(),
                    labelFontColor: "#000000",
                    labelAlign: "right",
                  }
                  ]
                },
                toolTip: {
                  contentFormatter: function (e) {
                    return  `${e.entries[0].dataPoint.label}:  `+e.entries[0].dataPoint.y+ ` ${chartDataOriginal[0].unit?chartDataOriginal[0].unit:" "}`;
                  },
                  enabled: true,
                }, 
                
                subtitles: [
                  {
                    text: chartDataOriginal[0].dataPoints.length === 0 ? "No data available." : "",
                    verticalAlign: "center",
                    horizontalAlign: 'center',
                    fontWeight: "bold"
                  }
                ],
              }]
            });
            chart2.render();

          }, 1000);
          
        }
      }).catch(error => {
        this.isLoading = false;
        this.errorMessage = "Failed to load data.";
        console.error(error);
      });
    }
  updateChartData(newData: any) {
    this.chartData = newData.chartData;
    this.chartOptions = newData.chartOptions;
    this.chartBgColors = newData.chartBgColors;
    this.cdr.detectChanges(); // Trigger change detection
  }

  evaluateRotatingAssetMovingAvg(chartType:string){
    let charts=['trends-acc','trends-temp','trends-velocity','trends-audible',
      'trends-usound','trends-flow','trends-pressure'
    ]
    return charts.includes(chartType)
  }

}